import { useEffect } from 'react';

import { DeviceType } from '@/modules/device/types';
import { useUserAgent } from '@/modules/device/useUserAgent';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';

export function useOutfitsUpsellExperiment() {
  const { device, isDeviceResolved } = useUserAgent();

  const isEligible = device === DeviceType.IOS || device === DeviceType.GENERAL;

  const [{ web_8669_outfits_homepage_upsell }, bucketFn] = useExperiments(
    ['web_8669_outfits_homepage_upsell'],
    { deferred: true }
  );

  useEffect(() => {
    if (isDeviceResolved && isEligible) {
      bucketFn();
    }
  }, [isDeviceResolved, isEligible, bucketFn]);

  const isVariant =
    isEligible && web_8669_outfits_homepage_upsell === VARIANT_IDENTIFIER;

  const isIos = device === DeviceType.IOS;

  return { isEligible, isVariant, isIos };
}
